import { useIsClientSide } from "@utils/hooks/isClient.hook";
import React from "react";

type ReviewsProps = {
    sku: string;
};

const ProductTileReviews = ({ sku }: ReviewsProps) => {
    const isClientSide = useIsClientSide();

    if (!isClientSide) {
        return null;
    }
    return <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>;
};

export { ProductTileReviews };
